import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/work9MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import { MainImage } from './workDetailPage/WorkMainImage';
import YouTubeEmbed from './components/YouTubeEmbed';
import BackButton from './components/BackButton';
import NextItem from './components/NextItem';
import thumbnail8 from './image/workThumbnails/thumbnail8.webp';
import { Hidden } from '@mui/material';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';
//NewVideoAds

function Work9(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    useMetaTags({
      title: 'New Video Ads - Lynkim',
      description: 'Introducing new vertical video ads on Karrot.',
      image: '/ogimage.png',
    });
    
    // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
    const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
    
    return (
      <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
      <>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      <div className='fadeIn '>
        <WorkTitle 
          title={'New Video Ads'} 
          description={'Introducing new vertical video ads on Karrot.'} 
          team={'Karrot(Daangn)'} 
          role={'UXUI Design, Data Experiment'} 
          period={'2024.01. - 2024.06.'}
          titleKo={'신규 비디오 광고'}
          descriptionKo={'당근에 세로형 비디오 광고 상품을 도입했습니다.'}
          teamKo={'당근마켓(Karrot)'}
          roleKo={'UXUI 디자인, 데이터 실험'}
        />
      </div>
      <div style = {{ overflow:'Hidden', maxHeight:'1000px', background:'linear-gradient(180deg, var(--color-bg-soft) 0%, var(--color-bg-mid) 100%)'}} >
      <video style = {{ width:"100%", aspectRatio: "auto", maxHeight:'800px'}}  loop autoPlay muted>
            <source src="/thumbnail9.mov" type="video/mp4" />
                Your browser does not support the video tag.
      </video>
      </div>
      <MainImage image={mainImage}/>
      <Waiting/>
      <BackButton/>
      <NextItem to='/Work8' thumbnail={thumbnail8} nextProjectTitle='A Bidding System in Search Ads'/>
      <div style={{ height: "400px" }} />
      </>
      </ProtectedPage>
    )
}

export default Work9;
